<template>
  <section class="upload-done">
    <header>
      <div class="title">
        <h1 v-if="$route.params.media === 'default'">{{ $t('create.doneTitleDefault') }}</h1>
        <h1 v-else>{{ $t('create.doneTitle') }}</h1>
      </div>
    </header>
    <div class="buttons">
      <router-link to="/media/create" tag="button">{{ $t('buttons.uploadMore') }}</router-link>
      <router-link to="/dashboard" class="alt-btn" tag="button">{{ $t('buttons.done') }}</router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'upload-done'
}
</script>

<style lang="scss" scoped>
.upload-done {
  text-align: center;

  button + button {
    margin-left: 25px;
  }
}
</style>
